import type { ApiResult } from '@/infra/api'
import { API_ENDPOINTS, httpGet, httpPost } from '@/infra/api'
import type {
  ApiKeyListItem,
  ApiKeyListParams,
  BulkActionResponse,
  DeleteHostsRequest,
  HostListItem,
  HostListParams,
  PagedResponse,
  RevokeApiKeysRequest,
} from './types'

export const settingsClient = {
  listApiKeys(params: ApiKeyListParams): Promise<ApiResult<PagedResponse<ApiKeyListItem>>> {
    return httpGet<PagedResponse<ApiKeyListItem>>(buildApiKeyListPath(params))
  },

  revokeApiKeys(request: RevokeApiKeysRequest): Promise<ApiResult<BulkActionResponse>> {
    return httpPost<BulkActionResponse>(API_ENDPOINTS.API_KEY_REVOKE, request)
  },

  listHostsPaginated(params: HostListParams): Promise<ApiResult<PagedResponse<HostListItem>>> {
    return httpGet<PagedResponse<HostListItem>>(buildHostListPath(params))
  },

  deleteHosts(request: DeleteHostsRequest): Promise<ApiResult<BulkActionResponse>> {
    return httpPost<BulkActionResponse>(API_ENDPOINTS.HOST_DELETE, request)
  },
}

// ---------------------------------------------------------------------------
// Private: Path builders
// ---------------------------------------------------------------------------

function buildApiKeyListPath(params: ApiKeyListParams): string {
  const searchParams = new URLSearchParams({
    page: params.page.toString(),
    size: params.size.toString(),
  })
  if (params.status) searchParams.set('status', params.status)
  if (params.environment && params.environment.length > 0) {
    searchParams.set('environment', params.environment.join(','))
  }
  if (params.sort) searchParams.set('sort', params.sort)
  return `${API_ENDPOINTS.API_KEY_LIST}?${searchParams.toString()}`
}

function buildHostListPath(params: HostListParams): string {
  const searchParams = new URLSearchParams({
    page: params.page.toString(),
    size: params.size.toString(),
  })
  if (params.sort) searchParams.set('sort', params.sort)
  return `${API_ENDPOINTS.HOST_LIST_PAGINATED}?${searchParams.toString()}`
}
